module.exports = __webpack_public_path__ + "static/rogerd-8af71c034adc1baaf9d6b0dbaf59a061.png";